$(function(){
  $('.hidden-text').readmore({
    speed: 1000,
    collapsedHeight: 85,
    moreLink: '<button type="button" class="readmore-btn more-text">続きを読む</button>',
    lessLink: '<button type="button" class="readmore-btn less-text">閉じる</button>'
  });
});

